import "./homeSection2.css";

const HomeSectionTwo = () => {
  return (
    <div
      className="home-main-sections"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div className="svg-wave">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 130"
          preserveAspectRatio="none"
          style={{ width: "100%", height: "130px", display: "block" }}
        >
          <path
            fill="#ffffff"
            d="M0,69.3L80,80.8C160,92.4,320,115.6,480,107.2C640,99,800,61.3,960,42.1C1120,23.1,1280,23.1,1360,23.1L1440,23.1L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
          />
        </svg>
      </div>

      <div className="home-section-two" id="donate-section">
        <div className="donate-content">
          <div className="banner-donate-text">
            <div className="banner-donate-text-heading">
              <div>
                Your gift today can help <span>change</span> the life of a
                graduate and their parents
              </div>
            </div>
            <a href="/donate-bent-christy-graduate-assistance-program">
              <button>
                <div className="text">DONATE</div>
                <div className="circle">
                  <img src="/icons/heart-white.png" alt="heart" />
                  <span className="text-over">TODAY</span>
                </div>
              </button>
            </a>
          </div>

          <div className="banner-donate-text-image">
            <img
              src="./images/home/image19-bg-no-2.png"
              alt="Donate BCGAP Image"
              fetchpriority="high"
            />
          </div>
        </div>
      </div>
      <div className="svg-wave-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 180"
          preserveAspectRatio="none"
          style={{ width: "100%", height: "180px", transform: "scaleY(-1)" }}
        >
          <path
            fill="white"
            d="M0,47.4L80,35.5C160,23.7,320,0,480,8C640,15.8,800,55.4,960,74.8C1120,94.2,1280,94.2,1360,94.2L1440,94.2L1440,0L0,0Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default HomeSectionTwo;
